/** Leaf flag — set when effective connectivity is unreachable; avoids subscriptionHealth ↔ effectiveConnectivity cycle. */

let realtimeSuppressed = false;

export function setRealtimeSuppressed(value) {
  realtimeSuppressed = Boolean(value);
}

export function isRealtimeSuppressed() {
  return realtimeSuppressed;
}
